'use strict';

var helper = require('../helper');

module.exports = {
    pushPlayVideoInteraction (name) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '33',
            'eventname': 'video_start',
            'type': 'play',
            'video_title': name
        };

        helper.log('Pushing tracking video - play:', true);
        helper.push(pushObject);
    },

    pushAutoPlayVideoInteraction (name) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '33',
            'eventname': 'video_start',
            'type': 'auto_play',
            'video_title': name
        };

        helper.log('Pushing tracking video - auto play:', true);
        helper.push(pushObject);
    },

    pushPauseVideoInteraction (name) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '34',
            'eventname': 'video_pause',
            'video_title': name
        };

        helper.log('Pushing tracking video - pause:', true);
        helper.push(pushObject);
    },

    pushFullVideoInteraction (name) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '35',
            'eventname': 'video_complete',
            'video_title': name
        };

        helper.log('Pushing tracking video - full screen:', true);
        helper.push(pushObject);
    },

    pushPercentage25VideoInteraction (name) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '36',
            'eventname': 'video_progress',
            'video_percent': '25',
            'video_title': name
        };

        helper.log('Pushing tracking video - 25:', true);
        helper.push(pushObject);
    },

    pushPercentage50VideoInteraction (name) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '37',
            'eventname': 'video_progress',
            'video_percentage': '50',
            'video_title': name
        };

        helper.log('Pushing tracking video - 50:', true);
        helper.push(pushObject);
    },

    pushPercentage75VideoInteraction (name) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '38',
            'eventname': 'video_progress',
            'video_percentage': '75',
            'video_title': name
        };

        helper.log('Pushing tracking video - 75:', true);
        helper.push(pushObject);
    }
};
